import { useEffect } from 'react';
import styled from 'styled-components';

// Components
import { Button, Modal, ModalProps } from '@gif/shared-ui';

// Hooks
import { useAdobeTracking } from '../../../hooks';

export interface MlbPlayModalProps extends ModalProps {
  title: string;
  bodyText: string;
  buttonText?: string;
  noteText?: string;
  testId: string;
  onButtonClick?: () => void;
}

const StyledMlbPlayModal = styled(Modal)`
  background-color: ${(props) => props.theme.surface};
  color: ${(props) => props.theme.fontColor};
  .closeModalIcon {
    background-color: ${(props) => props.theme.surface};
    color: ${(props) => props.theme.fontColor};
  }
`;

const Title = styled.h1`
  margin: 0.5rem 0;
  text-align: center;
  font-size: 1.19rem;
  font-weight: 600;
  line-height: 1.425rem;
`;

const BodyText = styled.p`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
`;

const Note = styled.p`
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5rem;
  margin-top: 2rem;
`;

const FullWidthButton = styled(Button)`
  width: 100%;
  &:focus-visible,
  button:focus-visible {
    outline: revert;
    border: white solid 0.25rem;
  }
`;

export const MlbPlayModal = ({
  title,
  bodyText,
  noteText,
  buttonText,
  onClose,
  onButtonClick,
  testId,
  ...rest
}: MlbPlayModalProps) => {
  // Analytics Page Tracking
  const { trackPageView } = useAdobeTracking();
  useEffect(() => {
    if (rest.isOpen) {
      trackPageView({
        type: 'Gaming Hub',
        subType: title,
      });
    }
  }, [rest.isOpen, title, trackPageView]);
  // End Analytics Page Tracking

  return (
    <StyledMlbPlayModal
      id="mlbPlayModal"
      testId={testId}
      showCloseIcon
      onClose={onClose}
      {...rest}
    >
      <Title>{title}</Title>
      <BodyText>{bodyText}</BodyText>
      {noteText && <Note>{noteText}</Note>}
      {onButtonClick && buttonText && (
        <FullWidthButton
          onClick={onButtonClick}
          data-testid={`${testId}-modalButton`}
        >
          {buttonText}
        </FullWidthButton>
      )}
    </StyledMlbPlayModal>
  );
};

export default MlbPlayModal;
